import dynamic from 'next/dynamic';

import LoadingSpinner from 'components/LoadingSpinner';

import type { Props } from './CampaignViewer';

const CampaignViewerSuspense = dynamic(() => import('./CampaignViewer'), {
	loading: () => <LoadingSpinner />,
});

export default function DynamicCampaignViewer(props: Props) {
	return <CampaignViewerSuspense {...props} />;
}
DynamicCampaignViewer.displayName = 'DynamicCampaignViewer';
